module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-layout"
  }, [_c('div', {
    staticClass: "form-rows"
  }, [_c('div', {
    staticClass: "fields input half",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.locale.text_email_address_label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": _vm.locale.text_email_address_label
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handle($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fields input half right"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('input', {
    staticClass: "cta-button blue",
    attrs: {
      "type": "button",
      "value": _vm.locale.button_request_password
    },
    on: {
      "click": _vm.handle
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-062b8b9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/forms/password.vue
// module id = 153
// module chunks = 0